const upsellPopup = document.getElementById('upsell-popup');
const upsellOverlay = document.getElementById('upsell-popup-overlay');
const closeButton = document.getElementById('upsell-popup-close');
const addToCartButton = document.getElementById('upsell-add-to-cart');
const checkoutButton = document.getElementById('cart-drawer-checkout-button');
const cartForm = document.getElementById('cart-drawer-form');

// Ensure checkout button always works as a fallback
if (checkoutButton) {
  const fallbackCheckoutHandler = (event) => {
    // Only add fallback if no other handler is working
    if (!event.defaultPrevented) {
      window.location.href = '/checkout';
    }
  };
  
  // Add fallback handler with lower priority
  checkoutButton.addEventListener('click', fallbackCheckoutHandler, false);
}

// Handle missing elements gracefully
if (!upsellPopup && !checkoutButton && !cartForm) {
  // No required elements found - exit early
} else if (!upsellPopup) {
  // Upsell popup elements not found - exit early
} else if (!checkoutButton || !cartForm) {
  // Cart drawer elements not found - exit early
}

// Only initialize functionality for elements that exist
if (upsellPopup && checkoutButton && cartForm) {
  const showPopup = () => {
    upsellPopup.classList.remove('hidden');
    if (upsellOverlay) {
      upsellOverlay.classList.remove('hidden');
    }
  };

  const hidePopupAndCheckout = () => {
    upsellPopup.classList.add('hidden');
    if (upsellOverlay) {
      upsellOverlay.classList.add('hidden');
    }
    window.location.href = '/checkout';
  };
  
  const checkoutClickHandler = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    const productInCart = upsellPopup.dataset.productInCart === 'true';

    if (productInCart) {
      window.location.href = '/checkout';
    } else {
      showPopup();
    }
  };

  checkoutButton.addEventListener('click', checkoutClickHandler, true);

  // Optional popup controls (only if they exist)
  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      hidePopupAndCheckout();
    });
  }

  if (upsellOverlay) {
    upsellOverlay.addEventListener('click', (event) => {
      event.preventDefault();
      hidePopupAndCheckout();
    });
  }

  if (addToCartButton) {
    addToCartButton.addEventListener('click', () => {
      const variantId = addToCartButton.dataset.variantId;
      const sellingPlanId = addToCartButton.dataset.sellingPlanId;
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };

      if (sellingPlanId) {
        formData.items[0].selling_plan = sellingPlanId;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/checkout';
      })
      .catch((error) => {
        window.location.href = '/checkout';
      });
    });
  }
} else {
  // Provide fallback behavior when some elements are missing
  
  // If we have a checkout button but no popup, just let it work normally
  if (checkoutButton && !upsellPopup) {
    // Checkout will work normally
  }
  
  // If we have popup elements but no cart drawer, the popup can still function independently
  if (upsellPopup && addToCartButton && (!checkoutButton || !cartForm)) {
    
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        upsellPopup.classList.add('hidden');
        if (upsellOverlay) {
          upsellOverlay.classList.add('hidden');
        }
      });
    }

    if (upsellOverlay) {
      upsellOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        upsellPopup.classList.add('hidden');
        upsellOverlay.classList.add('hidden');
      });
    }

    if (addToCartButton) {
      addToCartButton.addEventListener('click', () => {
        const variantId = addToCartButton.dataset.variantId;
        const sellingPlanId = addToCartButton.dataset.sellingPlanId;
        const formData = {
          'items': [{
            'id': variantId,
            'quantity': 1
          }]
        };

        if (sellingPlanId) {
          formData.items[0].selling_plan = sellingPlanId;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          upsellPopup.classList.add('hidden');
          if (upsellOverlay) {
            upsellOverlay.classList.add('hidden');
          }
          // Optionally redirect to cart or update cart display
          // window.location.href = '/cart';
        })
        .catch((error) => {
          // Handle error silently
        });
      });
    }
  }
} 